import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { DrToastrModule } from '@datarailsshared/datarailsshared';
import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './core/layout/layout.module';
import { HeapService } from './core/services/heap.service';
import { PlgTokenService } from './core/services/plg-token.service';
import { provideAnalytics } from '@datarails/analytics/angular';
import { AnalyticsSdkService } from './core/analytics/analytics-sdk.service';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        CoreModule,
        LayoutModule,
        MatLegacyDialogModule,
        DrToastrModule,
    ],
    providers: [
        provideLottieOptions({
            player: () => import('lottie-web'),
        }),
        provideCacheableAnimationLoader(),
        // Explicit events only — disable the package's DOM autotrack (the app uses
        // no data-dr-* attributes), avoiding unused global listeners + injection surface.
        ...provideAnalytics({ autotrack: false }),
        {
            // Sequenced on purpose: PlgTokenService.init() may flag a stale analytics
            // identity (new/changed HubSpot contact on this browser); AnalyticsSdkService.init()
            // must run AFTER it so it consumes that flag and clears Mixpanel's persisted
            // localStorage BEFORE mixpanel.init() reads it. Ordering is explicit here at the
            // composition root rather than relying on APP_INITIALIZER registration order.
            provide: APP_INITIALIZER,
            useFactory: (plgToken: PlgTokenService, analytics: AnalyticsSdkService) => async () => {
                await plgToken.init();
                await analytics.init();
            },
            deps: [PlgTokenService, AnalyticsSdkService],
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (heap: HeapService) => () => heap.init(),
            deps: [HeapService],
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
